let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("dXtRw"), load("c6MKV"), load("aZinD"), load("4Pn6Z"), load("9DDT5")]).then(() => parcelRequire('2TweP'));